import * as ReactDOM from 'react-dom/client';
import App from './app.jsx';

import './style.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);